import { SB } from '@play-co/replicant';

export const championsLeagueSchema = {
  championsLeague: SB.object({
    tutorialSeenAt: SB.int().optional(),
  }).optional(),
};
